var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/nodes/section.ts
import "@adornis/buildify/client/components/x-buildify-width-picker.js";
import { css } from "@adornis/chemistry/directives/css.js";
import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { PARAGRAPH_KEY } from "../../schema/nodes/paragraph.js";
import { SECTION_KEY, SECTION_SCHEMA } from "../../schema/nodes/section.js";
import { BuildifyLitElement } from "../BuildifyLitElement.js";
import { runInsertNode } from "../helper/runInsertNode.js";
import { MenuItemGroup } from "../types.js";
import { isNodeSelection } from "../util.js";
import { flexEditor } from "./flex.js";
var editor = ({
  content,
  contentController,
  controllerBaseKeyPath,
  host
}) => {
  return html`
    <x-flex space="sm">
      <x-buildify-width-picker
        clearable
        placeholder="Inhaltsbreite"
        ${contentController.field(...controllerBaseKeyPath, "contentWidthID")}
      ></x-buildify-width-picker>
      ${flexEditor({
    content,
    // @ts-expect-error its the same type
    contentController,
    controllerBaseKeyPath,
    host
  })}
    </x-flex>
  `;
};
var section = () => ({
  node: {
    name: SECTION_KEY,
    schema: SECTION_SCHEMA()
  },
  menuItems: [
    {
      group: MenuItemGroup.LAYOUT,
      label: "Section",
      icon: "fit_width",
      run: (view) => runInsertNode(SECTION_KEY, (state) => {
        return {
          content: [state.schema.nodes[PARAGRAPH_KEY].create()]
        };
      })(view.state, view),
      shouldVisualize: (view) => {
        return !isNodeSelection(view.state.selection);
      }
    }
  ],
  editor
});
var NodeSection = class extends BuildifyLitElement {
  content({ content, mode }) {
    return html`
      <x-section ${css({ border: `1px solid ${this.colors.accent.shade(200)}`, boxSizing: "border-box" })}>
        <slot></slot>
      </x-section>
    `;
  }
};
NodeSection = __decorateClass([
  customElement("node-section")
], NodeSection);
export {
  NodeSection,
  editor,
  section
};
